import React, { useEffect, useState } from "react"
import { withRouter, Link, useParams  } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { FiltersCard } from "components/Common/FiltersCard"
import Table from "./JackpotTicketBetTable"
import axios from "axios";
import {API_URL, sitename} from "../../../constants/constants";
import {showMessage} from "../../../components/Common/Toaster";
import {showErrorMessages} from "../../../helpers/helpers";
import moment from "moment";
const JackpotTicketsBet = props => {
    let { id } = useParams();
    const [item, setItem] = useState("All")
    const [jackpotReport, setJackpotReport] = useState([])
    const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"))
    const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"))
    const [modelData, setModalData] = useState([])
    const option = [
        { label: "All", value: "All" },
        { label: "1x2", value: "1x2" },
        { label: "u/0 2.5", value: "u/0 2.5" },
        { label: "BTTS", value: "BTTS" },
    ]

    useEffect(() => {
        call()
    }, [])

    const call = () => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/jackpot-bet-reports/${id}?from=${fromDate}&to=${toDate}&type=${item}`,
        })
            .then(function (response) {
                setJackpotReport(response?.data?.data)
            })
            .catch(function (response) {
                //handle error
                //  showErrorMessages(response)
            })
    }

    const callById =ticketid => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/jackpot-bet-reports/${id}?ticketid=${ticketid}&from=${fromDate}&to=${toDate}&type=${item}`,
        })
            .then(function (response) {
                setModalData(response?.data?.data[0])
            })
            .catch(function (response) {})
    }

    const cancelTicketCall = (id) => {
        axios({
            method: "get",
            url: `${API_URL}/admin/reports/cancel-tickets/${id}`,
        })
            .then(function (response) {
                showMessage("success", response.data.message)
                call();
            })
            .catch(function (response) {
                showErrorMessages(response)
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{sitename}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Admin" breadcrumbItem="Jackpot Tickets" />
                </Container>
                <FiltersCard item={item}
                             setItem={setItem}
                             options={option}
                             toDate={toDate}
                             setToDate={d => setToDate(d)}
                             setFromDate={d => setFromDate(d)}
                             filterLabel="Market"
                             fromDate={fromDate}
                             call={() => {
                                 call()
                             }}
                                hideShowType={false}
                />
                <Table data={jackpotReport}
                       callById={(ticketid) => {
                           callById(ticketid)
                       }}
                       modelData={modelData}
                       cancelTicketCall={(id) => {
                           cancelTicketCall(id)
                       }}
                />
            </div>
        </React.Fragment>
    )
}

export default withRouter(JackpotTicketsBet)
